import { useApiClient } from '@/composables/useApiClient'

export const state = () => ({
  activePromotes: [],
  inactivePromotes: [],
  bookingPromoList: [],
})

export const getters = {
  activePromotes: state => state.activePromotes,
  inactivePromotes: state => state.inactivePromotes,
  bookingPromoList: state => state.bookingPromoList,
}

export const actions = {
  getPromoList({ commit }) {
    const url = '/promo'
    return useApiClient()
      .$get(url)
      .then(res => {
        if (res.code === 0) {
          commit('SET_ACTIVE_PROMOTES', res.data.active)
          commit('SET_INACTIVE_PROMOTES', res.data.inactive)
        }
      })
  },
  getBookingWithUserPromo({ commit }, { pid, amount, productAmount, productQuantity, bookingTime }) {
    const url = `/promo/product/${pid}`
    const params = {
      amount,
      product_amount: productAmount,
      product_quantity: productQuantity,
      booking_time: bookingTime,
    }
    return useApiClient()
      .$get(url, { params: params, headers: { APIVer: 2 } })
      .then(res => {
        if (res.code === 0) {
          commit('SET_BOOKING_PROMO_LIST', res.data || [])
          return res
        }
      })
  },
}

export const mutations = {
  SET_ACTIVE_PROMOTES(state, promotes) {
    state.activePromotes = promotes
  },
  SET_BOOKING_PROMO_LIST(state, promoList) {
    state.bookingPromoList = promoList
  },
  SET_INACTIVE_PROMOTES(state, promotes) {
    state.inactivePromotes = promotes
  },
}
